import { useMemo } from 'react';
import classNames from 'classnames';
import { HistoryWeatherRow, HistoryWeatherRowHeader } from 'components/resort/SnowfallWeatherRow';
import { ISnowfallItem } from 'api/resort/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { AutoScroll } from 'components/blocks/AutoScroll';
import styles from './styles.module.scss';

type KeyAverage = 'totalSnow' | 'snowDays' | 'baseDepth' | 'summitDepth' | 'maxBaseDepth' | 'biggestSnowfall';

const applyArrayToSetAverageInstanceFunc = (arr: Array<ISnowfallItem>) => (property: KeyAverage) => {
  const sum = arr.reduce((prev, item) => prev + item[property], 0);
  return Math.ceil(sum / arr.length);
};

export const Annual = (
  { infoAnnual, visible }: { infoAnnual: Array<ISnowfallItem>, visible: boolean },
) => {
  const { t } = useOTSTranslation('common');
  const setAverageInstance = useMemo(() => applyArrayToSetAverageInstanceFunc(infoAnnual), [infoAnnual]);

  const average = useMemo(() => ({
    date: t('resort.historicalSnowfall.average'),
    totalSnow: setAverageInstance('totalSnow'),
    snowDays: setAverageInstance('snowDays'),
    baseDepth: setAverageInstance('baseDepth'),
    summitDepth: setAverageInstance('summitDepth'),
    maxBaseDepth: setAverageInstance('maxBaseDepth'),
    biggestSnowfall: setAverageInstance('biggestSnowfall'),
  }), [setAverageInstance]);

  const annualGridData = useMemo(() => [...infoAnnual, average], [infoAnnual]);

  return (
    <AutoScroll>
      <section className={classNames(styles.box, visible ? styles.visible : styles.invisible)}>
        <table className={classNames(styles.table)}>
          <HistoryWeatherRowHeader />
          <tbody>
            {annualGridData.map((item, index, arr) => (
              <HistoryWeatherRow
                key={item.date}
                snowfall={item}
                className={index % 2 ? '' : styles.other}
                average={item.date === t('resort.historicalSnowfall.average')}
                isLastRow={arr[index + 1]?.date === average.date}
                annual
              />
            ))}
          </tbody>
        </table>
      </section>
    </AutoScroll>
  );
};
